<script>import { trackComponent } from "@sentry/svelte";
trackComponent({ "trackInit": true, "trackUpdates": true, "componentName": "SelectAddress" });
import { SelectSingle } from "../../../../selects/index.js";
import { t } from "svelte-i18n";
export let key;
export let label = "resource.address.label";
export let addresses = [];
export let isDisabled = false;
export let isRequired = false;
const getName = ({ street, building, locality, countryCode }) => {
    let name = "";
    if (street !== void 0) {
        name += `${street} `;
    }
    if (building !== void 0) {
        name += `${building}, `;
    }
    if (locality !== void 0) {
        name += `${locality} - `;
    }
    name += $t(`global.country.${countryCode}`);
    return name.trim();
};
const format = (addresses2) => addresses2.map((address) => ({
    key: address._.key,
    label: getName(address)
}));
</script>

{#if addresses.length > 0}

    <SelectSingle
        bind:key
        name = 'address.key'
        options = { format(addresses) }
        placeholder = 'resource.address.placeholder'
        { label }
        { isDisabled }
        { isRequired }
    />

{/if}